
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'

export default {
    name: viewName.paction,
    components: {
    },
    data () {
        return {
            type: 'user', // user: 用户协议, privacy: 隐私政策
        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {
        this.setAppClass({
            isAppend: false,
            className: 'bgWhiteColor'
        })
    },
    activated () {

    },
    mounted () {
        document.body.scrollIntoView()
        const { type } = this.$route.query
        this.type = type && type
        this.$emit('setHeader', {
            title: this.type === 'user' ? '用户协议' : '隐私政策',
            showHeader: true,
            showLeft: true,
            hasSearch: false
        })
    },
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
    },
    destroyed () {

    },
}
